import { getFunctions, httpsCallable } from 'firebase/functions';
import { getAuth, signInWithCustomToken, signOut as firebaseSignOut } from 'firebase/auth';
import { app } from './config';
import { FUNCTIONS_REGION } from './region';

/**
 * The client sends a phone and a code and receives a token. It never sends a
 * uid, never sends a "verified" flag, and never decides anything: the server
 * resolves the account in the same call that verified the code.
 */
export async function requestOtp(phone: string): Promise<void> {
  const call = httpsCallable<{ phone: string }, { sent: boolean }>(getFunctions(app, FUNCTIONS_REGION), 'sendOtp');
  await call({ phone });
}

export async function submitOtp(phone: string, code: string): Promise<{ isNewUser: boolean }> {
  const call = httpsCallable<{ phone: string; code: string }, { token: string; isNewUser: boolean }>(
    getFunctions(app, FUNCTIONS_REGION),
    'verifyOtpAndSignIn'
  );
  const res = await call({ phone, code });
  await signInWithCustomToken(getAuth(app), res.data.token);
  return { isNewUser: res.data.isNewUser };
}

export async function signOut(): Promise<void> {
  await firebaseSignOut(getAuth(app));
}
